import { Text } from 'app/design/primitives/text';
import { View } from 'react-native';
import { HubButton, styles } from '../components';

import type { OfferHubState } from '../hooks';

export function OfferHubStorageNotice({ t, queue, session }: Pick<OfferHubState, 't' | 'queue' | 'session'>) {
  return (
    <View style={styles.notice}>
      <Text accessibilityRole="alert" variant="bodySmall">
        {t('storageError')}
      </Text>
      <HubButton
        tone="outline"
        onPress={() => {
          queue?.retry();
          void session.retry();
        }}
      >
        {t('retry')}
      </HubButton>
    </View>
  );
}
